<template>
	<div class="element_wrpr form-block-wrpr"
	     :class="[{'current': edit, }, 'block_element_wrpr_' + content.type]"
	     @mousenter="hover=true" @mouseleave="hover=false" @mouseover="hover=true"
	     :style="[{margin}, {width: 'auto'}, getResponsive]" @click.stop="activeteRow">

		<div class="left_top_controls__hover">
			{{ content.type }}
		</div>
		<div class="left_top_controls block-drag">
            <span class="drag_arrow_icon">
                <i class="icon icon-drag"></i>
            </span>
			{{ content.type }}
		</div>

		<div class="right_top_controls">
			<a class="right_top_controls_btn" :title="'Edit '+ content.type" @click.stop.prevent="activeteRow">
				<i class="icon icon-settings"></i>
			</a>
			<a class="right_top_controls_btn"  v-if="canDelete" :title="'Delete '+ content.type" @click.stop.prevent="deleteItem">
				<i class="icon icon-delete"></i>
			</a>
		</div>

		<slot></slot>
	</div>
</template>

<script>
import {mapGetters} from "vuex"
import {getPadding} from "@/modules/page-editor/src/utils/props";

export default {
	name: 'FormBlockWrapper',
	props: ['id', 'index', 'parentId', 'formElementData', 'block','parent'],
	computed: {
		...mapGetters(['page_findOne', 'page_findChild', 'page_tab']),
		content() {
			return this.block; // this.page_findOne(this.id);
		},
		getResponsive() {
			var globalView = this.$store.state.page.view;
			var currentView = this.content.responsive;
			if (currentView && !currentView[globalView]) return {display: 'none'}
			else return {display: 'flex'}
		},
		basic() {
			return this.content.attributes.basic
		},
		edit() {
			return this.block.selected;
		},
		canDelete() {
			return this.edit && (this.formElementData.type !== 'formButton');
		},
		margin() {
			return getPadding(this.basic.margin)
		}
	},
	methods: {
		activeteRow() {
			let tab = 'basic';
			if (this.page_tab==='advanced') tab='advanced';
			this.$store.commit('PAGE_SET_TABID', {tab: tab, id: this.id, block:this.block});
		},
		deleteItem() {
			// Select the parent form first then delete the element, to avoid no focus.
			this.$store.commit('PAGE_SET_TABID', {tab: 'basic', id: this.parentId, block:parent});
			this.$store.commit('PAGE_REMOVE_FORM_CHILDREN', {
				itemId: this.id,
				itemIndex: this.index,
				form: this.parentId,
				stepNumber: this.formElementData.step,
			});
		},
	},
}
</script>
<style lang="scss" scoped>
.plus_input_btn_dropdown {
	// To prevent the page font from replacing it.
	font-family: $default-font-family;
	font-size: 10px;
	font-weight: 400;
}

.block-wrapper {
	pointer-events: none;
}

.form-block-wrpr {
	//pointer-events: all;
	.left_top_controls__hover {
		display: flex;
		align-items: center;
		padding: 0;
		position: absolute;
		left: 0;
		top: -17px;
		font-weight: 400;
		font-size: 10px;
		color: $sharp-blue;
		background: transparent;
		font-family: $default-font-family;
		opacity: 0;
	}

	&:not(.current):hover {
		.left_top_controls__hover {
			opacity: 1;
		}
	}

	.left_top_controls {
		display: flex;
		align-items: center;
		border-radius: 3px 3px 0 0;
		height: 27px;
		padding: 0 10px;
		position: absolute;
		left: -2px;
		top: -27px;
		line-height: 150%;
		letter-spacing: 0.02em;
		color: #FFFFFF;
		background: $sharp-blue;

		// To prevent the page font from replacing it.
		font-family: $default-font-family;
		font-size: 10px;
		text-transform: capitalize;
		font-weight: 500;
	}

	.bottom_plus_btn {
		transition: 0.15s all ease-in-out;

		&:hover {
			transform: scale(1.2);
		}

		svg {
			z-index: 2;
		}
	}
}
</style>
